// extracted by mini-css-extract-plugin
module.exports = {"base":"InPageNav_base__UkGIv"};